const types = {
    SET_ONE_CLICK_PRESCRIBE_QUEUE_LOADING: 'SET_ONE_CLICK_PRESCRIBE_QUEUE_LOADING',
    SET_ONE_CLICK_PRESCRIBE_QUEUE: 'SET_ONE_CLICK_PRESCRIBE_QUEUE',
    REMOVE_ONE_CLICK_PRESCRIBE_CASE_FROM_QUEUE: 'REMOVE_ONE_CLICK_PRESCRIBE_CASE_FROM_QUEUE',
    ADD_CASE_TO_ONE_CLICK_PRESCRIBE_QUEUE: 'ADD_CASE_TO_ONE_CLICK_PRESCRIBE_QUEUE',
    MARK_ONE_CLICK_PRESCRIBE_CASE_SUCCESSFUL: 'MARK_ONE_CLICK_PRESCRIBE_CASE_SUCCESSFUL',
    ACKNOWLEDGE_FLAGGED_CASE: 'ACKNOWLEDGE_FLAGGED_CASE',
};

export default types;

